exports.LANGUAGE = {
  en: 'English',
  'zh-Hant': '繁體中文',
  ja: '日本語'
};
exports.LANGUAGE_NAME = {
  en: '英文',
  'zh-Hant': '繁体中文',
  ja: '日语'
};
exports.XIGUA_LANGUAGE = {
  en: 'en',
  'zh-Hant': 'zh-Hant',
  ja: 'ja'
};

exports.ZT_LANGUAGE = {
  en: 'en',
  'zh-Hant': 'cht',
  ja: 'jp'
};

/**
 *
 * zho（简体中文）
 * eng（英文）
 * zho-tw（台湾）
 * zho-hk（香港）
 * udm（维吾尔语）
 * jpn（日文）
 * ind（印尼）
 * kor（韩语）
 * rus（俄语）
 * ara（阿拉伯语）
 * spa（西班牙语）
 * pon（巴西葡语）
 * por（欧洲葡语）
 * fra（法语）
 * deu（德语）
 * @type {{de: string, 'zh-HANT': string, ru: string, ko: string, th: string, ja: string, en: string, it: string, id: string, fr: string, es: string}}
 */
exports.GEETEST_LANGUAGE = {
  en: 'eng',
  'zh-Hant': 'zho-hk',
  ja: 'jpn'
};

exports.TDK = {
  en: {
    title: 'Mecha BREAK Official Site — Sign Up for Closed Beta!',
    keywords: 'Mecha BREAK, Mecha BREAK Official Site, Mecha BREAK Beta Registration, Mech Game, Sci-Fi, Shooter',
    description:
      'Sign up for Closed Beta now! Get early access to the global launch of our new game mode, Mashmak. Squad up for some epic co-op action, beyond the usual PvP battles.'
  },
  ja: {
    title: '『Mecha BREAK』公式サイトクローズドβテスト募集中',
    keywords: 'Mecha BREAK, Mecha BREAK公式サイト,Mecha BREAK事前予約, メカゲーム, SFゲーム,シューティングゲーム',
    description: 'クローズドβテスト募集中！マシュマーク降下作戦世界初公開、PvPのほか、探索やチームを組み共に戦おう'
  },

  'zh-Hant': {
    title: '《Mecha BREAK》官方網站 — 封閉Beta測試招募中',
    keywords: 'Mecha BREAK，Mecha BREAK官網，Mecha BREAK預約，機甲遊戲，科幻遊戲，射擊遊戲',
    description: '封閉Beta測試招募中！一同參與全球首次Mashmak降下作戰，探索除PvP對戰外的機甲團隊共鬥'
  }
};

const pcTest = '//test-zt.xoyo.games/www.mechabreak.com/p/m/2024/03/15/dlc/';
const pcMaster = '//www.mechabreak.com/m/';
exports.PC_ADDRESS = {
  en: {
    testUrl: pcTest + 'en/',
    masterUrl: pcMaster + 'en/'
  },
  ja: {
    testUrl: pcTest + 'ja/',
    masterUrl: pcMaster + 'ja/'
  },

  'zh-Hant': {
    testUrl: pcTest + 'zh-Hant/',
    masterUrl: pcMaster + 'zh-Hant/'
  }
};

exports.PROTOCOL = {
  en: {
    appointment: '//www.mechabreak.com/show-1034-38-1.html',
    cookie: '//www.mechabreak.com/show-1031-35-1.html',
    privacy: '//www.mechabreak.com/show-1031-29-1.html',
    service: '//www.mechabreak.com/show-1031-33-1.html'
  },
  ja: {
    appointment: '//www.mechabreak.com/show-1031-41-1.html',
    cookie: '//www.mechabreak.com/show-1031-36-1.html',
    privacy: '//www.mechabreak.com/show-1031-28-1.html',
    service: '//www.mechabreak.com/show-1031-32-1.html'
  },

  'zh-Hant': {
    appointment: '//www.mechabreak.com/show-1031-39-1.html',
    cookie: '//www.mechabreak.com/show-1031-34-1.html',
    privacy: '//www.mechabreak.com/show-1031-26-1.html',
    service: '//www.mechabreak.com/show-1031-30-1.html'
  }
};
